<template>
  <div class="cards-grid-container">
    <v-card
      v-for="(card, i) in cardsWithValue"
      :key="'admin-card-' + i"
      class="card-data"
      :class="{ 'card-data-active': isActive(card) }"
      @mousedown="$emit('select-card', i)"
      :elevation="0"
      :ripple="false"
      style="cursor: pointer"
      :style="getCardStyle(card)"
    >
      <v-card-text>
        <div class="card-content">
          <div class="card-icon">
            <v-icon :color="card.color" size="40">
              {{ card.icon }}
            </v-icon>
          </div>

          <div class="d-flex flex-column">
            <span class="card-title">{{ card.title }}</span>

            <span class="card-value" :style="{ color: card.color }">
              {{ card.value }}
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AdminSuperAdminCard",

  props: {
    usersData: {
      type: Array,
      required: true,
    },
    selectedCardIndex: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      baseCards: [
        {
          key: "all_admins",
          title: "All",
          icon: "mdi-account-group-outline",
          color: "#0EA5E9",
          activeBg: "#E0F7FF",
          activeBorder: "#38BDF8",
        },
        {
          key: "admin_all",
          title: "Admin",
          icon: "mdi-account-tie-outline",
          color: "#6366F1",
          activeBg: "#ECEBFF",
          activeBorder: "#818CF8",
        },
        {
          key: "superadmin_all",
          title: "SuperAdmin",
          icon: "mdi-shield-account-outline",
          color: "#EF4444",
          activeBg: "#FFECEC",
          activeBorder: "#F87171",
        },
      ],
    };
  },

  computed: {
    cardsWithValue() {
      const normalizeRole = (role) => {
        const r = (role || "").trim().toLowerCase();
        if (r === "admin") return "admin";
        if (r === "superadmin") return "superadmin";
        return "other";
      };

      return this.baseCards.map((card, index) => {
        let value = 0;

        if (card.key === "all_admins") {
          value = this.usersData.filter(
            (u) => ["admin", "superadmin"].includes(normalizeRole(u.role))
          ).length;
        }

        if (card.key === "admin_all") {
          value = this.usersData.filter(
            (u) => normalizeRole(u.role) === "admin"
          ).length;
        }

        if (card.key === "superadmin_all") {
          value = this.usersData.filter(
            (u) => normalizeRole(u.role) === "superadmin"
          ).length;
        }

        return { ...card, value, index };
      });
    },
  },

  methods: {
    isActive(card) {
      return card.index === this.selectedCardIndex;
    },

    getCardStyle(card) {
      if (!this.isActive(card)) return {};

      return {
        background: card.activeBg,
        border: `1px solid ${card.activeBorder}`,
      };
    },
  },
};
</script>

<style scoped>
.card-data {
  border-radius: 16px;
  border: 1px solid #f3f5f7;
  background: #ffffff;
  min-height: 120px;
  display: flex;
  align-items: center;
}

.card-data:hover {
  transform: scale(1.02);
  transition: transform 0.2s ease-in-out;
  z-index: 10;
}

.card-data:hover:not(.card-data-active) {
  background-color: #f9fafb;
  border-color: #d1d5db;
}

.card-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.card-value {
  font-size: 24px;
  font-weight: 700;
}

.cards-grid-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

@media (max-width: 1023px) {
  .cards-grid-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .cards-grid-container {
    grid-template-columns: 1fr;
  }
}
</style>
